(function () {
  'use strict';
  
  try {
    /* Main variables */
    const debug = 0;
    const variation_name = "consolidated";
    
    /* Helper functions */
    function waitForElement(selector, trigger, delayInterval = 50, delayTimeout = 15000) {
      const interval = setInterval(function () {
        if (
          document &&
          document.querySelector(selector) &&
          document.querySelectorAll(selector).length > 0
        ) {
          clearInterval(interval);
          trigger();
        }
      }, delayInterval);
      
      setTimeout(function () {
        clearInterval(interval);
      }, delayTimeout);
    }

    /* AB004 - Collection Page Button Text Change */
    function initAB004() {
      document.body.classList.add('AB004');

      document.querySelectorAll('.spf-product-card .spf-product__form button > span').forEach((btnSpan) => {
        if (btnSpan.innerText.trim().toLowerCase() === "add to cart") {
          btnSpan.innerText = "Shop Now";
        }
      });
      
      document.querySelectorAll('.spf-product-card .spf-product__form button').forEach((button) => {
        button.addEventListener('click', function (event) {
          event.preventDefault();
          const productCard = button.closest('.spf-product-card');
          const link = productCard.querySelector('.spf-product-card__inner a');
          if (link) {
            link.click();
          }
        });
      });
    }

    /* History change listener for SPA-like behavior */
    function setupHistoryListener() {
      window.addEventListener("locationchange", function () {
        waitForElement('.spf-product-card .spf-product__form button', initAB004, 50, 15000);
      });
      
      // Override history methods to detect navigation
      const originalPushState = history.pushState;
      const originalReplaceState = history.replaceState;
      
      history.pushState = function() {
        const ret = originalPushState.apply(this, arguments);
        window.dispatchEvent(new Event('pushstate'));
        window.dispatchEvent(new Event('locationchange'));
        return ret;
      };
      
      history.replaceState = function() {
        const ret = originalReplaceState.apply(this, arguments);
        window.dispatchEvent(new Event('replacestate'));
        window.dispatchEvent(new Event('locationchange'));
        return ret;
      };
      
      window.addEventListener("popstate", () => {
        window.dispatchEvent(new Event('locationchange'));
      });
    }

    /* Main initialization */
    function init() {
      // Initialize AB004 (collection page buttons) if elements exist
      if (document.querySelector('.spf-product-card .spf-product__form button')) {
        initAB004();
      }
      
      // Setup history listener for dynamic content
      setupHistoryListener();
    }

    /* Initialize when DOM is ready */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

  } catch (e) {
    if (debug) console.log(e, "error in " + variation_name);
  }
})();
